import PaymentState from "@/models/Accounts/Shared/Payments/PaymentState";

export default (paymentState: PaymentState) => {
    let returnVal = "Undefined";
    switch (paymentState) {
        case PaymentState.PendingApproval:
            returnVal = "Pending Approval"
            break;
        case PaymentState.Scheduled:
            returnVal = "Scheduled"
            break;
        case PaymentState.Submitted:
            returnVal = "Submitted"
            break;
        case PaymentState.Processing:
            returnVal = "Processing"
            break;
        case PaymentState.Accepted:
            returnVal = "Accepted"
            break;
        case PaymentState.Completed:
            returnVal = "Completed"
            break;
        case PaymentState.UserCancelled:
            returnVal = "User Cancelled"
            break;
        case PaymentState.UserRejected:
            returnVal = "User Rejected"
            break;
        case PaymentState.Rejected:
            returnVal = "Rejected"
            break;
        case PaymentState.Failed:
            returnVal = "Failed"
            break;
        case PaymentState.Expired:
            returnVal = "Expired"
            break;
        case PaymentState.MonitoringHeld:
            returnVal = "Monitoring Held"
            break;
        case PaymentState.MonitoringRejected:
            returnVal = "Monitoring Rejected"
            break;
    }
    return returnVal;
}